var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:[_vm.color, _vm.color !='' ? 'white--text': ''],domProps:{"innerHTML":_vm._s(_vm.textoHTML)}})])}
var staticRenderFns = []

export { render, staticRenderFns }